import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import styles from './sidebar.module.scss';
import {
  HomeOutlined,
  UserOutlined,
  ProductOutlined,
  FileTextOutlined,
  FundViewOutlined,
  LogoutOutlined,
  MenuOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { logout } from '../../services/authService';
import { useAuth } from '../../auth/AuthContext';


const { Sider } = Layout;

const Sidebar = () => {
  // const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useAuth();

  // const toggleCollapsed = () => {
  //   setCollapsed(prev => !prev);
  // };

  const userLogout = async (e) => {
    e.preventDefault();
    try {
      await logout();
    } catch (err) {
    } finally {
      auth.logout();
      localStorage.removeItem('token');
      navigate('/login', { replace: true });
    }
  }

  const menuItems = [
      // {
      //   key: 'toggle',
      //   icon: collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />,
      //   label: 'Menu',
      //   onClick: toggleCollapsed,
      // },
      {
        key: '/home',
        icon: <HomeOutlined />,
        label: <Link to="/home">HOME</Link>,
      },
      {
        key: '/customers',
        icon: <UserOutlined />,
        label: <Link to="/customers">CUSTOMERS</Link>,
      },
    //   {
    //     key: '/import-customers',
    //     icon: <ImportOutlined />,
    //     label: <Link to="/import-customers">Import Customers</Link>,
    //   },
      {
        key: '/products',
        icon: <ProductOutlined />,
        label: <Link to="/products">PRODUCTS</Link>,
      },
      {
        key: '/subscriptions',
        icon: <FundViewOutlined />,
        label: <Link to="/subscriptions">SUBSCRIPTIONS</Link>,
      },
      {
        key: '/invoices',
        icon: <FileTextOutlined />,
        label: <Link to="/invoices">INVOICES</Link>,
      },
      {
        key: '/settings',
        icon: <SettingOutlined />,
        label: <Link to="/settings">SETTINGS</Link>,
      },
      {
        key: '/logout',
        icon: <LogoutOutlined  />,
        label: <a href='/logout' onClick={(e) => userLogout(e)}>LOGOUT</a>,
      },
  ];

  const getSelectedMenuKey = (pathname) => {
    if (pathname.startsWith('/customers')) return '/customers';
    if (pathname.startsWith('/products')) return '/products';
    if (pathname.startsWith('/subscriptions')) return '/subscriptions';
    if (pathname.startsWith('/settings')) return '/settings';
    return pathname;
  };

  return (
    <Sider
      className={styles.sider}
      breakpoint="md"
      collapsedWidth="0"
      width={110}
      theme='light'
      trigger={<MenuOutlined />}
      zeroWidthTriggerStyle={{
        top: 6,
        backgroundColor: '#646464',
        color: '#FFFFFF',
        borderTopRightRadius: 6,
        borderBottomRightRadius: 6,
      }}
    >
      <div className="logo" />
      <Menu
        theme="light"
        mode="inline"
        defaultSelectedKeys={['1']}
        items={menuItems}
        selectedKeys={[getSelectedMenuKey(location.pathname)]}
        className={styles.tileMenu}
      />
    </Sider>
  );
};

export default Sidebar;
